export default "__VITE_ASSET__zi5rvNMG__"